'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = {
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: ''
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-date-picker/lib/locale/en_US.js
 ** module id = 425
 ** module chunks = 0
 **/